import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocFlat(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M90.571 99.875c6.312 0 11.429-5.117 11.429-11.429H44.857c0 6.312-5.117 11.429-11.428 11.429H90.57Z"
        fill="#E2E8F0"
      />
      <path
        d="M33.429 99.875C27.117 99.875 22 94.758 22 88.446V19.875h57.143v68.571c0 6.312 5.117 11.429 11.428 11.429H33.43Z"
        fill="#F1F5F9"
      />
      <path
        d="M78.343 88.446c0 6.754 5.475 12.229 12.228 12.229a.8.8 0 1 0 0-1.6c-5.87 0-10.628-4.759-10.628-10.629a.8.8 0 1 0-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M37.532 37.311a2.507 2.507 0 0 0-3.319.768l-.09.143a1.366 1.366 0 0 0-.012.02l-4.003 6.888-.118.228a2.484 2.484 0 0 0 1.033 3.175c1.192.684 2.72.28 3.41-.91l1.853-3.187 1.852 3.187a2.505 2.505 0 0 0 3.41.91 2.483 2.483 0 0 0 .916-3.403l-4.003-6.887-.013-.02-.089-.143a2.485 2.485 0 0 0-.827-.769Zm3.548 8.623a.883.883 0 0 1-.328 1.211.904.904 0 0 1-1.23-.326l-2.31-3.976 1.036-1.783 2.832 4.874Zm-5.72-3.09-2.31 3.975a.904.904 0 0 1-1.23.326.883.883 0 0 1-.329-1.21l2.833-4.875 1.037 1.783Zm.474-4.143a.907.907 0 0 1 .902-.001h.001a.888.888 0 0 1 .328 1.21l-.779 1.342-.78-1.341a.88.88 0 0 1 0-.886v-.001a.885.885 0 0 1 .328-.323Z"
        fill="#78B441"
      />
      <path
        d="M30.572 78.122a.8.8 0 0 0 0 1.601h40a.8.8 0 0 0 0-1.6h-40Zm0-5.713a.8.8 0 1 0 0 1.6h40a.8.8 0 1 0 0-1.6h-40Zm0-5.715a.8.8 0 0 0 0 1.6h40a.8.8 0 0 0 0-1.6h-40Zm0-5.714a.8.8 0 0 0 0 1.6h40a.8.8 0 1 0 0-1.6h-40Zm0-5.714a.8.8 0 1 0 0 1.6h40a.8.8 0 0 0 0-1.6h-40Zm17.142-5.715a.8.8 0 0 0 0 1.6h22.858a.8.8 0 1 0 0-1.6H47.713Zm0-5.714a.8.8 0 0 0 0 1.6h22.858a.8.8 0 1 0 0-1.6H47.713Zm0-5.715a.8.8 0 0 0 0 1.601h22.858a.8.8 0 0 0 0-1.6H47.713Zm0-5.714a.8.8 0 0 0 0 1.6h22.858a.8.8 0 1 0 0-1.6H47.713Z"
        fill="#B3C0D0"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocFlat)
